import Tags from './Tags.vue';

export default Tags;
